import {api} from '../../contexts/AuthContext';
import {CreateUserData, User} from '../../types';

// User API (Admin only)
export const userApi = {
    getAllUsers: async (): Promise<User[]> => {
        const response = await api.get('/api/users');
        return response.data;
    },

    getUserById: async (id: string): Promise<User> => {
        const response = await api.get(`/api/users/${id}`);
        return response.data;
    },

    createUser: async (userData: CreateUserData): Promise<User> => {
        const response = await api.post('/api/users', userData);
        return response.data;
    },

    updateUser: async (id: string, updates: Partial<User>): Promise<User> => {
        const response = await api.put(`/api/users/${id}`, updates);
        return response.data;
    },

    deleteUser: async (id: string): Promise<void> => {
        await api.delete(`/api/users/${id}`);
    }
};
